import { BackendHttpService } from './backendHttpService';
import { getShowExperimental } from './experimentalOverrideService';

export interface FeatureFlags {
  talentMarket?: boolean;
  enableSkillAssignment?: boolean;
  enableCertificateManagement?: boolean;
}

// These two flags are an emergency backend-enforced block (ADR_2026-09-23_01) —
// "Show Experimental" must never override them locally, since the backend would still reject writes.
const EMERGENCY_BLOCKED_FLAGS: (keyof FeatureFlags)[] = [
  'enableSkillAssignment',
  'enableCertificateManagement',
];

export class FeatureFlagsService extends BackendHttpService {
  constructor() {
    super('FeatureFlags');
  }

  async getFeatureFlags(): Promise<FeatureFlags> {
    const flags = await this.get<FeatureFlags>('');
    if (getShowExperimental()) {
      return Object.fromEntries(
        Object.keys(flags).map((k) => [
          k,
          EMERGENCY_BLOCKED_FLAGS.includes(k as keyof FeatureFlags)
            ? flags[k as keyof FeatureFlags]
            : true,
        ])
      ) as FeatureFlags;
    }
    return flags;
  }
}
